<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Acknowledgments</span></h1>
<p class="P_Normal">This book would only be half as good if not for my wonderful publisher, Elizabeth North. Not to mention only half as long. Thank you for encouraging me to expand the story, and allowing me the time to do so.</p>
<p class="P_Normal">Thank you to my amazing and supportive editors, Jessie and Desi, for seeing everything I missed and putting a stop to my comma abuse.</p>
<p class="P_Normal">I’d also like to thank the generous betas who read this story and didn’t pull their punches: Jade Crystal, Morticia Knight, and Elin Gregory. You gals rock!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?119a2163